import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=a884cf06&"
import script from "./topic.vue?vue&type=script&lang=ts&"
export * from "./topic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a884cf06')) {
      api.createRecord('a884cf06', component.options)
    } else {
      api.reload('a884cf06', component.options)
    }
    module.hot.accept("./topic.vue?vue&type=template&id=a884cf06&", function () {
      api.rerender('a884cf06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/searchbar/decorators/topic.vue"
export default component.exports